export default {
    title: 'Share',
    embedding: {
        title: 'Embed trend radar',
        sharingDisabled: 'Sharing (embedding) is disabled',
        label: 'URL for embedding',
        switch: {
            true: 'activated',
            false: 'deactivated'
        },
        tooltip: {
            copy: 'Copy URL',
            success: 'URL copied successfully',
            published: 'The trend radar has to be published first',
            copyDisabled: 'The embed trend radar option is disabled'
        }
    },
    publicView: {
        title: 'Public link',
        sharingDisabled: 'Sharing (PublicView) is disabled',
        label: 'URL for public view',
        switch: {
            true: 'activated',
            false: 'deactivated'
        },
        tooltip: {
            copy: 'Copy URL',
            success: 'URL copied successfully',
            published: 'The trend radar has to be published first',
            copyDisabled: 'The URL option is disabled'
        }
    },
    empty: 'The trend radar can be shared as soon as it is published',
    openPreview: 'Open public trend radar preview',
    edit: {
        tooltip: 'Customize logo',
        close: 'Close logo customization'
    },
    logo: {
        title: 'Logo',
        emptyState: 'No logo has been assigned yet'
    },
    preview: {
        title: 'Public trend radar preview',
        tooltip: 'Open public trend radar preview'
    }
}
